import { Fragment, FunctionComponent, RefObject, useEffect, useRef, useState } from "react";
import { observer } from "mobx-react-lite";

import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { classNames } from "primereact/utils";

import { TooltipWrapper } from "../../Components/TooltipWrapper/TooltipWrapper";

import "./ProgressButton.scss";

interface IProgressButtonProps {
  ref?: RefObject<any>;
  className?: string;
  size?: "small" | "large" | undefined;
  progressText?: string | undefined;
  tooltip?: string;
  tooltipShowDelay?: number;
  tooltipPosition?: "top" | "bottom" | "left" | "right" | "mouse";
  tooltipDisabled?: boolean;
  disabled?: boolean;
  onClick?: (event: any) => void;
  children?: React.ReactNode;
}

const RawProgressButton: FunctionComponent<IProgressButtonProps> = (props: IProgressButtonProps) => {
  const buttonRef = props.ref ?? useRef<HTMLButtonElement>(null);

  const [inProgress, setInProgress] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    setInProgress(!!props.progressText?.length);
  }, [props.progressText]);

  useEffect(() => {
    setDisabled(inProgress || !!props.disabled);
  }, [props.disabled, inProgress]);

  return (
    <Fragment>
      <TooltipWrapper
        targetRef={buttonRef}
        content={props.tooltip ?? ""}
        showOnDisabled={true}
        showDelay={props.tooltipShowDelay ?? 0}
        position={props.tooltipPosition ?? "top"}
        disabled={props.tooltipDisabled || !disabled}
      />

      <Button
        ref={buttonRef}
        className={classNames(`progress-button ${props.className}`)}
        size={props.size}
        onClick={event => !disabled && props.onClick?.(event)}
        disabled={disabled}
      >
        {inProgress ? (
          <Fragment>
            <span>{props.progressText}</span>
            <ProgressSpinner className="inline-spinner" strokeWidth="6" />
          </Fragment>
        ) : (
          props.children
        )}
      </Button>
    </Fragment>
  );
};

export const ProgressButton = observer(RawProgressButton);
